export const USER_FETCHED = 'effector.user.fetched'
